import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDataProvider } from 'src/app/common/utils';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useIntl } from 'react-intl';
import CriteriaSettingList from './components/CriteriaSettingList';
import { CriteriaPaginateList, CriteriaResultListParam } from '../../../types/criteria-setting';
import { fetchCriteriaResultList } from '../../../network/criteriaCrud';

type CriteriaSettingListingPageProps = {} & ParamsProps;

const initialState: CriteriaResultListParam = {
  name: '',
  page: 1,
  limit: 5,
};

export const criteriaFilterKeys = ['name'];

const paramsInitiator = (initialParams?: Record<string, string>): CriteriaResultListParam => {
  return initialParams
    ? {
        name: initialParams.name || '',
        page: 1,
        limit: 5,
      }
    : initialState;
};

const CriteriaSettingListingPage: FC<CriteriaSettingListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<CriteriaResultListParam>(paramsInitiator(initialParams));
  const [sortKey, setSortKey] = useState<{ key: string; value?: string }[]>([]);
  const [criteriaList, setCriteriaList] = useState<CriteriaPaginateList>();

  const updateSortingKey = (sortingKey: { key: string; value?: string }) => {
    const sortingKeyArray = sortKey.filter((currentValue, index, arr) => {
      return currentValue.key !== sortingKey.key;
    });
    sortingKeyArray.unshift(sortingKey);
    setSortKey(sortingKeyArray);
    refreshData();
  };

  const { isLoading, refreshData } = useDataProvider<CriteriaPaginateList>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchCriteriaResultList(filterState, sortKey, dispatch);
      } catch (err) {}
    },
    setCriteriaList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('criteriaSetting.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'name',
            initialValue: filterState.name,
            displayName: Translation('criteriaSetting.name'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            name: data.name,
          })
        }
        fetchData={refreshData}
      />
      <CriteriaSettingList
        isLoading={isLoading}
        onRefresh={refreshData}
        criteriaList={criteriaList}
        onSort={(dataKey) => updateSortingKey(dataKey)}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default CriteriaSettingListingPage;
